import { Reducer } from 'redux';
import { IAction } from '../types';
import { localKeyInfo } from '../config';
import LocalStore from '@/utils/store';

export interface ValidateInfoState {
  roomId: number;
  livePlatform?: string;
}

const LOCALKEY = localKeyInfo.validateInfo;
const localVoiceInfo = LocalStore.getValue<ValidateInfoState>(LOCALKEY) || {};

export const validateInfo: ValidateInfoState = {
  roomId: 0,
  ...localVoiceInfo
};

export const setValidateInfo: (payload: ValidateInfoState) => IAction<ValidateInfoState> = (
  payload: ValidateInfoState
) => ({
  type: 'setValidateInfo',
  payload
});

const validateInfoReducer: Reducer<ValidateInfoState, IAction<any>> = (state = validateInfo, action: IAction<any>) => {
  const { type, payload } = action;
  switch (type) {
    case 'setValidateInfo':
      LocalStore.setValue(LOCALKEY, payload);
      return {
        ...payload
      };
    default:
      return state;
  }
};

export default validateInfoReducer;
